AFRAME.registerComponent('cursor-listener', {
    init: function () {
        this.originalColor =  this.el.getAttribute('color') || '#0066cc';

        this.el.addEventListener('mouseenter', () => {
            this.el.setAttribute('material', 'opacity', 1.0);
            this.el.setAttribute('color', '#3399ff');
        });

        this.el.addEventListener('mouseleave', () => {
            this.el.setAttribute('material', 'opacity', 0.8);
            this.el.setAttribute('color', this.originalColor);
        });
    }
});

AFRAME.registerComponent('ticker-news', {
    schema: {
        ticker: { type: 'string', default: 'BUSINESS' },
        position: { type: 'vec3' }
    },

    init: async function () {
        console.log('init: Starting initialization');
        this.articles = [];
        this.overlay = null;

        try {
            this.apiManager = await NewsProxyAPIManager.create();
            console.log('init: NewsProxyAPIManager initialized successfully');
        } catch (error) {
            console.error('init: Failed to initialize MediastackAPIManager: ', error.message);
            return;
        }

        this.setupNewsFilters();

        this.activeWatchlistId = null; 

        this.onWatchlistDataLoaded = this.onWatchlistDataLoaded.bind(this);
        document.body.addEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        
        this.onAuthSessionChanged = this.onAuthSessionChanged.bind(this);
        document.addEventListener('auth:session-changed', this.onAuthSessionChanged);

        this.onWatchlistAuthChanged = this.onWatchlistAuthChanged.bind(this);
        document.addEventListener('watchlist:auth-changed', this.onWatchlistAuthChanged);
        
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const isWatchlistMode = document.body.classList.contains('watchlist-mode');
                    
                    if (isWatchlistMode && !this.wasInWatchlistMode) {
                         const State = window.WatchlistApp?.State;
                         if (State?.currentWatchlistId) {
                             this.activeWatchlistId = State.currentWatchlistId;
                         }
                         this.syncFiltersUI('watchlist');
                         this.data.ticker = 'BUSINESS'; 
                         this.update({ticker: 'FORCE_UPDATE'});
                    } else if (!isWatchlistMode && this.wasInWatchlistMode) {
                        console.log('Exited watchlist mode, reverting to ticker news');
                        this.syncFiltersUI('general');
                        this.data.ticker = 'BUSINESS'; 
                        this.update({ticker: 'FORCE_UPDATE'}); 
                    }
                    this.wasInWatchlistMode = isWatchlistMode;
                }
            });
        });
        this.observer.observe(document.body, { attributes: true });


        try {
             if (document.body.classList.contains('watchlist-mode')) {
                 const State = window.WatchlistApp?.State;
                 if (State?.currentUserId && State?.currentWatchlistId) {
                     this.syncFiltersUI('watchlist');
                     this.update({ticker: 'FORCE_UPDATE'});
                 } else {
                      this.articles = await this.fetchArticles();
                      this.news = this.createNews(this.articles);
                 }
             } else {
                this.articles = await this.fetchArticles();
                this.news = this.createNews(this.articles);
             }
            try {
                const leftPanel = document.getElementById('large-left-panel');
                const leftContent = document.getElementById('large-left-panel-content');
                const newsEntity = document.getElementById('ticker-news');
                const articleCount = Array.isArray(this.articles) ? this.articles.length : 0;
                console.debug('[ticker-news:init] Containers and state', {
                    leftPanelExists: !!leftPanel,
                    leftContentExists: !!leftContent,
                    newsEntityExists: !!newsEntity,
                    articleCount
                });
            } catch(_) { /* no-op */ }
        } catch (error) {
            console.error('init: Failed to fetch articles:', error.message);
            this.showError(this.news, 'Failed to fetch articles: ' + error.message);
        }

        const leftNewsBlock = document.querySelector('#left-container');
        const backToListButtonHTML = document.querySelector('#left-container .news-mode .title-block .img-wrapper')
        if (backToListButtonHTML) {
            backToListButtonHTML.addEventListener('click', () => {
                leftNewsBlock.classList.remove('news-open');
            });
        }

        const readFullHTML = document.querySelector('#left-container .news-mode .read-full');
        if (readFullHTML) {
            readFullHTML.addEventListener('click', () => {
                if (window.gtag) gtag('event', 'Desktop_LeftPanel_ClickOnNewsReadFull');
            })
        } 

        this.newsScheduler = new window.AutoRefreshScheduler({
            name: 'TickerNews',
            onRefresh: () => {
                this.update({ticker: 'FORCE_UPDATE'});
            }
        });
        
        this.newsScheduler.start();
    },

    setupNewsFilters: function() {
        const generalBtn = document.querySelector('.variant[data-filter="general"]');
        const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
        
        if (!generalBtn || !watchlistBtn) return;

        watchlistBtn.style.opacity = '1';
        watchlistBtn.style.pointerEvents = 'auto';
        watchlistBtn.title = "";

        generalBtn.addEventListener('click', () => {
             this.syncFiltersUI('general');
             this.data.ticker = 'BUSINESS';
             this.update({ticker: 'FORCE_UPDATE'});
             
             if (window.gtag) gtag('event', 'Desktop_LeftPanel_GeneralBusiness');
        });

        watchlistBtn.addEventListener('click', async () => {
            const State = window.WatchlistApp?.State;
            const Manager = window.WatchlistApp?.Manager;
            
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }

            let isLoggedIn = false;
            if (window.currentSession && window.currentSession.user) {
                if (!window.currentSession.user.is_anonymous) {
                    isLoggedIn = true;
                }
            } else {
                try {
                    const sessionStr = localStorage.getItem('auth_session');
                    if (sessionStr) {
                        const sessionItem = JSON.parse(sessionStr);
                        if (sessionItem && sessionItem.expiry && Date.now() < sessionItem.expiry) {
                            const user = sessionItem.value?.user;
                            if (user && !user.is_anonymous) {
                                isLoggedIn = true;
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error checking login status', e);
                }
            }

            if (!isLoggedIn) {
                 const message = 'Log in to access watchlist';
                 
                 if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                    window.WatchlistApp.Popup.showNotificationPopup('Watchlist Access', message);
                } else {
                    alert(message);
                }
                return;
            }

            if (!State.allWatchlists || State.allWatchlists.length === 0) {
                 if (Manager && Manager.updateWatchlistState) {
                      console.log('Loading watchlists for filter...');
                      await Manager.updateWatchlistState();
                 }
            }
            
            const allWatchlists = State?.allWatchlists || [];
            if (allWatchlists.length > 0) {
                 this.activeWatchlistId = allWatchlists[0].id;
                 console.log(`Switched to Watchlist filter. Active Watchlist: ${this.activeWatchlistId} (${allWatchlists[0].name})`);
            } else {
                 this.activeWatchlistId = null; 
            }

             this.syncFiltersUI('watchlist');
             this.data.ticker = 'BUSINESS';
             this.update({ticker: 'FORCE_UPDATE'});

            if (window.gtag) gtag('event', 'Desktop_LeftPanel_WatchlistButton');
        });
    },

    syncFiltersUI: function(mode) {
        const generalBtn = document.querySelector('.variant[data-filter="general"]');
        const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
        if (!generalBtn || !watchlistBtn) return;

        if (mode === 'watchlist') {
            generalBtn.classList.remove('active');
            watchlistBtn.classList.add('active');
        } else {
            watchlistBtn.classList.remove('active');
            generalBtn.classList.add('active');
        }
    },

    update: async function (oldData) {
        if (!this.apiManager || !this.apiManager.isInitialized) {
            console.log('MediastackAPIManager not yet initialized, skipping update');
            return;
        }
        
        if (oldData.ticker !== this.data.ticker || oldData.position !== this.data.position || oldData.ticker === 'FORCE_UPDATE') {
            console.log(`update: Ticker changed from ${oldData.ticker} to ${this.data.ticker} or position updated`);
            try {
                this.articles = await this.fetchArticles();
                this.createNews(this.articles);
                console.log('update: createArticles completed');
            } catch (error) {
                console.error('update: Failed to fetch articles:', error.message);
                this.showError(this.news, 'Failed to fetch articles:  ' + error.message);
            }
        }
    },

    async onWatchlistDataLoaded() {
        const State = window.WatchlistApp?.State;
        if (State?.currentWatchlistId) {
            this.activeWatchlistId = State.currentWatchlistId;
        }

        const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
        const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');

        if (isWatchlistFilterActive && this.data.ticker === 'BUSINESS') {
            console.log('onWatchlistDataLoaded: Triggering reload for watchlist overview news');
            this.update({ticker: 'FORCE_UPDATE'});
        }
    },

    onAuthSessionChanged: function(e) {
        const session = e.detail?.session;
        if (!session) {
            const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
            const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');
            
            if (isWatchlistFilterActive) {
                this.syncFiltersUI('general');
                this.data.ticker = 'BUSINESS';
                this.update({ticker: 'FORCE_UPDATE'});
            }
        }
    },

    onWatchlistAuthChanged: function(e) {
        if (e.detail?.reason === 'consent_revoked') {
            const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
            const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');
            
            if (isWatchlistFilterActive) {
                this.syncFiltersUI('general');
                this.data.ticker = 'BUSINESS';
                this.update({ticker: 'FORCE_UPDATE'});
            }
        }
    },

    createNews: function (articles) {
        if (this.news) {
            this.news.remove();
        }
        console.log('createNews: Creating news panel', articles)

        const news = document.createElement('a-plane');
        news.setAttribute('width', '7.8');
        news.setAttribute('height', '7');
        news.setAttribute('scale', '1 1 1');
        news.setAttribute('color', '#888');
        news.setAttribute('opacity', '0');
        news.setAttribute('position', `-0.25 ${this.data.position.y} ${this.data.position.z}`);
        while (news.childNodes.length > 0) {
            news.replaceChildren();
        }

        const headerRow = document.createElement('a-rounded-plane');
        headerRow.setAttribute('width', '7.5');
        headerRow.setAttribute('height', '0.7');
        headerRow.setAttribute('position', '-3.75 3.2 0.02');
        headerRow.setAttribute('color', '#444');
        news.appendChild(headerRow);

        const headerTitle = document.createElement("a-troika-text");
        let headerText = `News - ${this.data.ticker}`;
        if (articles.isWatchlistNews && articles.watchlistName) {
            headerText = `${window.WatchlistApp.Utils.truncateName(articles.watchlistName, 20)}`;
        }
        headerTitle.setAttribute("value", headerText);
        headerTitle.setAttribute("position", "1.5 0.35 0.01");
        headerTitle.setAttribute("font-size", "0.25");
        headerTitle.setAttribute("color", "white");
        headerTitle.setAttribute("align", "left");
        headerTitle.setAttribute("anchor", "left");
        headerTitle.setAttribute("depth-offset", "1");
        headerTitle.setAttribute("baseline", "center");
        headerRow.appendChild(headerTitle);

        const newsParentHTML = document.querySelector('#left-container .news-list');
        if (newsParentHTML) newsParentHTML.innerHTML = ''
        const newsBlockTitle = document.querySelector('#left-container .preview-mode .title h3')
        if (newsBlockTitle) {
             let titleText = `News - ${this.data.ticker}`;
             if (articles.isWatchlistNews && articles.watchlistName) {
                 titleText = `${window.WatchlistApp.Utils.truncateName(articles.watchlistName, 20)} News`;
             } else if (this.data.ticker === 'BUSINESS') {
                 titleText = 'General Business News';
             }
             newsBlockTitle.textContent = titleText;
        }

        const exchangeNameFromData = (this.data.ticker) ? this.data.ticker.split(':')[0] : ''
        
        if (articles?.noArticles) {
            const noNewsText = document.createElement("a-troika-text");
            let message = `No articles found for stock ${articles.tickerSymbol}`;
            const exchangeName = articles.exchange || exchangeNameFromData
            if (exchangeName) {
                message += ` on exchange ${exchangeName}`;
            }
            
            noNewsText.setAttribute("value", message);
            noNewsText.setAttribute("position", "0 0 0.01");
            noNewsText.setAttribute("font-size", "0.3");
            noNewsText.setAttribute("color", "white");
            noNewsText.setAttribute("align", "center");
            noNewsText.setAttribute("max-width", "7");
            noNewsText.setAttribute("depth-offset", "1");
            news.appendChild(noNewsText);

            if (newsParentHTML) newsParentHTML.innerHTML = message

        } else if (Array.isArray(articles) && articles.length > 0) {
            let newsHTML = '';

            articles.forEach((article, index) => {
                const yPos = 2.5 - (index * 1.0);
                this.addArticle(news, article, yPos, index);
                
                const publishedDate = new Date(article.publishedDate).toLocaleDateString('en-US', {
                    year: '2-digit',
                    month: 'numeric',
                    day: 'numeric'
                });
                
                newsHTML += `
                <div class="news-item">
                    <div class="line">
                        <div class="source">${this.decodeHtmlEntities(article.publisher)}</div>
                        <div class="date">${publishedDate}</div>
                    </div>
                    <div class="main-text">
                       ${this.decodeHtmlEntities(article.title)}
                    </div>
                    <button class="read-full">
                        <p>Read</p>
                        <img src="./desktop_assets/left-block/arrow-right.svg" alt="">
                    </button>
                </div>`;
            });

            const newsParentHTML = document.querySelector('#left-container .news-list');
            if (newsParentHTML) {
                newsParentHTML.innerHTML = newsHTML;
                
                const allReadFullButtons = newsParentHTML.querySelectorAll('.read-full');
                const allTitles = newsParentHTML.querySelectorAll('.main-text');
                const leftNewsBlock = document.querySelector('#left-container');
                
                const openNewsHTML = (index) => {
                    const article = articles[index];
                    if (!article) return;
                    
                    const newsCategoryHTML = document.querySelector('#left-container .news-mode .header-block .category');
                    const newsCategoryGeneralTitle = document.querySelector('#left-container .preview-mode .title h3');
                    const newsDateHTML = document.querySelector('#left-container .news-mode .header-block .date');
                    const titleHTML = document.querySelector('#left-container .news-mode .header-block .title');
                    const authorHTML = document.querySelector('#left-container .news-mode .header-block .author');
                    const descriptionHTML = document.querySelector('#left-container .news-mode .description');
                    const readFullHTML = document.querySelector('#left-container .news-mode .read-full');

                    if (newsCategoryHTML) newsCategoryHTML.innerHTML = (newsCategoryGeneralTitle ? newsCategoryGeneralTitle.textContent : 'NEWS');
                    if (newsDateHTML) newsDateHTML.innerText = new Date(article.publishedDate).toLocaleDateString('en-US', {
                        year: '2-digit',
                        month: 'numeric',
                        day: 'numeric'
                    });
                    if (titleHTML) titleHTML.innerText = this.decodeHtmlEntities(article.title);
                    if (authorHTML) authorHTML.innerText = this.decodeHtmlEntities(article.publisher);
                    if (descriptionHTML) descriptionHTML.innerText = this.decodeHtmlEntities(article.description);
                    if (readFullHTML) readFullHTML.href = article.url;

                    if (leftNewsBlock) leftNewsBlock.classList.add('news-open');
                    
                    if (window.gtag) gtag('event', 'Desktop_LeftPanel_ClickOnNewsExpand');
                };

                allReadFullButtons.forEach((button, index) => {
                    button.addEventListener('click', () => openNewsHTML(index));
                });
                allTitles.forEach((title, index) => {
                    title.addEventListener('click', () => openNewsHTML(index));
                });
            }

        } else {
            let message = `No articles found for stock ${articles.tickerSymbol}`;
            const exchangeName = articles.exchange || exchangeNameFromData
            if (exchangeName) {
                message += ` on exchange ${exchangeName}`;
            }
            
            const noNewsText = document.createElement("a-troika-text");
            noNewsText.setAttribute("value", message);
            noNewsText.setAttribute("position", "0 0 0.01");
            noNewsText.setAttribute("font-size", "0.3");
            noNewsText.setAttribute("color", "white");
            noNewsText.setAttribute("align", "center");
            noNewsText.setAttribute("max-width", "7");
            noNewsText.setAttribute("depth-offset", "1");
            news.appendChild(noNewsText);

            if (newsParentHTML) newsParentHTML.innerHTML = message
        }

        this.el.appendChild(news);
        this.news = news;
        console.log('createNews: News container created and appended to this.el at: ', this.data.position);
        return news;
    },

    getExchangeFromCache: function (ticker) {
        const cacheKey = `ticker_${ticker}`;
        try {
            const cachedData = getCacheItem(cacheKey);
            if (!cachedData) {
                console.debug(`No cache entry for ${ticker}`);
                return null;
            }

            const exchange = cachedData.tickerDetails?.primary_exchange || cachedData.tickerSummary?.primary_exchange || null;
            console.debug(`Retrieved exchange for ${ticker}: ${exchange}`);
            return exchange;
        } catch (error) {
            console.error(`Error accessing cache for ${ticker}:`, error.message);
            return null;
        }
    },

    async fetchArticles() {
        if (!this.apiManager) {
            throw new Error("News Proxy Manager not initialized yet.");
        }

        const watchlistBtn = document.querySelector('.variant[data-filter="watchlist"]');
        const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');

        if (isWatchlistFilterActive && this.data.ticker === 'BUSINESS') {
             const State = window.WatchlistApp?.State;
             let userId = State?.currentUserId;
             if (!userId) {
                 try {
                     const sessionStr = localStorage.getItem('auth_session');
                     if (sessionStr) {
                         const sessionItem = JSON.parse(sessionStr);
                         userId = sessionItem.value?.user?.id || sessionItem.value?.user?.user_id; 
                     }
                 } catch(e) {}
             }
             const watchlistId = this.activeWatchlistId || State?.currentWatchlistId;
             
             const allWatchlists = State?.allWatchlists || [];
             const currentWatchlist = allWatchlists.find(w => w.id === watchlistId);
             const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';

             if (userId && watchlistId) {
                 console.log(`fetchArticles: Fetching Watchlist news for: ${watchlistName} (ID: ${watchlistId})`);
                 try {
                     const articles = await this.apiManager.getWatchlistNews(userId, watchlistId);
                     articles.isWatchlistNews = true;
                     articles.watchlistName = watchlistName;
                     return articles;
                 } catch (err) {
                     console.error('fetchArticles: Failed to fetch watchlist news:', err);
                     throw err;
                 }
             } else {
                 console.warn('fetchArticles: Watchlist filter active but missing userId or watchlistId', { userId, watchlistId });
             }
        }

        if (this.data.ticker.toUpperCase() === 'BUSINESS') {
            const articles = await this.apiManager.fetchStockNews('BUSINESS', 7, null, null);
            if (articles.length === 0) {
                return { noArticles: true, tickerSymbol: 'BUSINESS', exchange: null };
            }
            return articles;
        }

        let tickerSymbol = this.data.ticker;
        if (tickerSymbol.includes(':')) {
            tickerSymbol = tickerSymbol.split(':')[1];
        }
        const exchange = this.getExchangeFromCache(tickerSymbol);
        const searchTerm = exchange ? `${exchange}:${tickerSymbol}` : tickerSymbol;
        console.debug(`Fetching news for searchTerm: ${searchTerm}`);

        try {
            const articles = await this.apiManager.fetchStockNews(searchTerm, 7);
            if (articles.length === 0) {
                return { noArticles: true, tickerSymbol, exchange };
            }
            return articles;
        } catch (error) {
            console.error(`Error fetching news for ${searchTerm}:`, error.message);
            throw new Error(`Failed to fetch news for ${searchTerm}: ${error.message}`);
        }
    },

    decodeHtmlEntities: function(str) {
        if (!str) return '';
        const parser = new DOMParser();
        const decoded = parser.parseFromString(str, "text/html");
        return decoded.documentElement.textContent;
    },

    addArticle: function (parent, article, yPos, index) {
        const articleContainer = document.createElement('a-rounded-plane');
        articleContainer.setAttribute('width', '7.5');
        articleContainer.setAttribute('height', '0.8');
        articleContainer.setAttribute('position', `-3.75 ${yPos - 0.2} 0.03`);
        articleContainer.setAttribute('color', '#2F2F2F');

        const titleText = document.createElement("a-troika-text");
        const truncatedTitle = article.title.length > 60
            ? article.title.slice(0, article.title.lastIndexOf(' ', 60)) + "..."
            : article.title;
        titleText.setAttribute("value", truncatedTitle);
        titleText.setAttribute("position", "0.5 0.8 0.03");
        titleText.setAttribute("color", "white");
        titleText.setAttribute("font-size", "0.18");
        titleText.setAttribute("align", "left");
        titleText.setAttribute("anchor", "left");
        titleText.setAttribute("baseline", "top");
        titleText.setAttribute("max-width", "4");
        titleText.setAttribute("depth-offset", "1");
        titleText.setAttribute("overflow-wrap", "normal");
        articleContainer.appendChild(titleText);

        const infoText = document.createElement("a-troika-text");
        const publishedDate = new Date(article.publishedDate).toLocaleDateString('en-US', {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric'
        });
        infoText.setAttribute("value", `${article.publisher} - ${publishedDate}`);
        infoText.setAttribute("position", "4 0.3 0.03");
        infoText.setAttribute("font-size", "0.15");
        infoText.setAttribute("align", "left");
        infoText.setAttribute("anchor", "left");
        infoText.setAttribute("baseline", "top");
        infoText.setAttribute("color", "white");
        infoText.setAttribute("max-width", "4");
        infoText.setAttribute("depth-offset", "1");
        infoText.setAttribute("overflow-wrap", "normal");
        articleContainer.appendChild(infoText);

        const urlPlane = document.createElement("a-plane");
        urlPlane.setAttribute("position", "6.8 0.55 0.01");
        urlPlane.setAttribute("width", "1.2");
        urlPlane.setAttribute("height", "0.4");
        urlPlane.setAttribute("color", "#0066cc");
        urlPlane.setAttribute("material", "opacity: 1");
        urlPlane.setAttribute("cursor-listener", "");
        urlPlane.setAttribute("data-raycastable", "");

        urlPlane.addEventListener('fusing', () => urlPlane.setAttribute('scale', '1.1 1.1 1'));
        urlPlane.addEventListener('mouseleave', () => urlPlane.setAttribute('scale', '1 1 1'));

        urlPlane.addEventListener("click", () => this.showOverlay(article));
        articleContainer.appendChild(urlPlane);

        const urlText = document.createElement("a-troika-text");
        urlText.setAttribute("value", "Read More");
        urlText.setAttribute("position", "0 0 0.01");
        urlText.setAttribute("font-size", "0.16");
        urlText.setAttribute("color", "#EEE");
        urlText.setAttribute("align", "center");
        urlText.setAttribute("baseline", "center");
        urlPlane.appendChild(urlText);

        parent.appendChild(articleContainer);
    },

    showOverlay: function (article) {
        if (this.overlay) {
            this.overlay.remove();
        }

        this.overlay = document.createElement('a-rounded-plane');
        this.overlay.setAttribute('width', '7.8');
        this.overlay.setAttribute('height', '7.8');
        this.overlay.setAttribute('color', '#222');
        this.overlay.setAttribute('opacity', '1');
        this.overlay.setAttribute('position', `-4.2 -3.9 0.11`);

        const descText = document.createElement("a-troika-text");
        const truncatedDesc = article.description.length > 200
            ? article.description.slice(0, article.description.lastIndexOf(' ', 200)) + "..."
            : article.description;
        descText.setAttribute("value", article.description);
        descText.setAttribute("position", "0.2 7 0.01");
        descText.setAttribute("font-size", "0.22");
        descText.setAttribute("color", "white");
        descText.setAttribute("max-width", "7");
        descText.setAttribute("align", "left");
        descText.setAttribute("anchor", "left");
        descText.setAttribute("baseline", "top");
        descText.setAttribute("overflow-wrap", "normal");
        this.overlay.appendChild(descText);

        const linkPlane = document.createElement("a-rounded-plane");
        linkPlane.setAttribute("width", "6");
        linkPlane.setAttribute("height", "0.9");
        linkPlane.setAttribute("position", "0.2 0.4 0.01");
        linkPlane.setAttribute("color", "#0066cc");
        linkPlane.setAttribute("material", "opacity: 1");
        linkPlane.setAttribute("cursor-listener", "");
        linkPlane.setAttribute("data-raycastable", "");

        linkPlane.addEventListener('fusing', () => linkPlane.setAttribute('scale', '1.1 1.1 1'));
        linkPlane.addEventListener('mouseleave', () => linkPlane.setAttribute('scale', '1 1 1'));

        linkPlane.addEventListener("click", () => {
            const sceneEl = document.querySelector("a-scene");
            const isInVR = sceneEl && sceneEl.is('vr-mode');
            window.open(article.url, "_blank", isInVR ? "" : "width=800,height=600,toolbar=no,menubar=no");
            this.hideOverlay();
        });
        this.overlay.appendChild(linkPlane);

        const linkText = document.createElement("a-troika-text");
        linkText.setAttribute("value", "Click here to read the whole article in a browser window\nClick Meta button on right controller to view browser\n Close browser tab then click 'Resume' to return");
        linkText.setAttribute("position", "3 0.45 0.01");
        linkText.setAttribute("font-size", "0.18");
        linkText.setAttribute("color", "#EEE");
        linkText.setAttribute("align", "center");
        linkText.setAttribute("baseline", "center");
        linkText.setAttribute("width", "6.5");
        linkText.setAttribute("overflow-wrap", "normal");
        linkPlane.appendChild(linkText);

        const closePlane = document.createElement("a-plane");
        closePlane.setAttribute("width", "0.3");
        closePlane.setAttribute("height", "0.3");
        closePlane.setAttribute("position", "7.2 7.2 0.2");
        closePlane.setAttribute("color", "red");
        closePlane.setAttribute("material", "opacity: 1");
        closePlane.setAttribute("cursor-listener", "");
        closePlane.setAttribute("data-raycastable", "");
        closePlane.addEventListener("click", () => this.hideOverlay());
        this.overlay.appendChild(closePlane);

        const closeText = document.createElement("a-troika-text");
        closeText.setAttribute("value", "X");
        closeText.setAttribute("position", "0 0 0.01");
        closeText.setAttribute("font-size", "0.2");
        closeText.setAttribute("color", "white");
        closeText.setAttribute("align", "center");
        closeText.setAttribute("baseline", "center");
        closePlane.appendChild(closeText);

        this.overlay.addEventListener("click", (evt) => {
            if (evt.target === this.overlay) {
                this.hideOverlay();
            }
        });

        this.el.appendChild(this.overlay);
    },

    hideOverlay: function () {
        if (this.overlay) {
            this.overlay.setAttribute('animation', 'property: opacity; from: 0.9; to: 0; dur: 300; easing: easeInOutQuad;');
            setTimeout(() => {
                if (this.overlay) {
                    this.overlay.remove();
                    this.overlay = null;
                }
            }, 300);
        }
    },

    showError: function (parent, message) {
        console.log('showError: Displaying error:', message);
        if (!parent) {
             const newsParentHTML = document.querySelector('#left-container .news-list');
             if (newsParentHTML) {
                 newsParentHTML.innerHTML = `<div style="text-align: center; color: red; padding: 20px;">${message}</div>`;
             }
            console.error('showError:  Parent (news) is not initialized');
            return;
        }
        while (parent.childNodes.length > 0) {
            parent.replaceChildren();
        }
        const errorText = document.createElement("a-troika-text");
        errorText.setAttribute("value", message);
        errorText.setAttribute("position", "0 0 0.01");
        errorText.setAttribute("font-size", "0.3");
        errorText.setAttribute("color", "red");
        errorText.setAttribute("align", "center");
        errorText.setAttribute("max-width", "7");
        parent.appendChild(errorText);
    },

    remove: function() {
        if (this.newsScheduler) {
            this.newsScheduler.stop();
        }
        if (this.onWatchlistDataLoaded) document.body.removeEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        if (this.onAuthSessionChanged) document.removeEventListener('auth:session-changed', this.onAuthSessionChanged);
        if (this.onWatchlistAuthChanged) document.removeEventListener('watchlist:auth-changed', this.onWatchlistAuthChanged);
        if (this.observer) this.observer.disconnect();
    }
});
